import React from "react";
import { Label } from "semantic-ui-react";

const styles = {
	mainContainer: {
		backgroundColor: "#fff",
		padding: 10,
		boxShadow: "0px 9px 35px -23px rgba(148,148,148,1)",
		borderRadius: "4px",
		width: "100%",
	},
	title: {
		color: "#00917d",
		fontWeight: 600,
		textTransform: "uppercase",
		fontSize: "0.9em",
	},
	content: {
		paddingTop: 20,
	},
};

const AdminDisabledField = ({ title, value, isLongText = false }) => {
	if (value !== "")
		return (
			<div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", flexDirection: isLongText ? "column" : "row" }}>
				<span>{title} :</span>
				<span style={{ paddingRight: "5px", paddingLeft: "5px" }}>
					{value === true ? (
						<Label size="small" style={{ color: "green" }}>
							Oui
						</Label>
					) : value === false ? (
						<Label size="small" style={{ color: "red" }}>
							Non
						</Label>
					) : value === "" ? (
						<span style={{ paddingRight: "10px" }}>/</span>
					) : (
						<Label>{isLongText ? value.split(/(?:\r\n|\r|\n)/g).reduce((prev, curr) => [prev, <br />, curr]) : value}</Label>
					)}
				</span>
			</div>
		);
	return null;
};

export default AdminDisabledField;
